import { useState } from 'react';
import './index.css';

export const TextInput = ({ label, leftIcon, rightIcon, placeholder, value, onChange, type = "text", error = false, onEnter }) => {

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="text-input-container">
      {label && <span className="text-input-container-label">{label}<i className="text-input-container-label-required">*</i></span>}
      <div className={`text-input-container-input-container ${isFocused ? "text-input-container-input-container-focused" : ""} ${error ? "text-input-container-input-container-error" : ""}`}>
        {leftIcon && <img src={leftIcon} alt="left-icon" className="text-input-container-input-container-left-icon" />}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && onEnter) {
              if (onEnter) {
                onEnter();
              }
            }
          }} />
        {rightIcon && <img src={rightIcon} alt="right-icon" className="text-input-container-input-container-right-icon" />}
      </div>
      {error && <span className="text-input-container-error-message">{error}</span>}
    </div>
  );
};